import type { FC, HTMLProps } from "react";

import { ButtonBase, LinkBase } from "./Button.styles";

import type { ButtonProps } from "./Button.d";
import { isValidButtonType } from "./isValidButtonType";

export const Button: FC<
	Omit<HTMLProps<HTMLButtonElement | HTMLAnchorElement>, keyof ButtonProps> &
	ButtonProps
> = ({
	children,
	color,
	pseudoColor = color,
	...props
}) => {
		if (props.as === "a")
			return (
				<LinkBase
					{...props}
					$color={color}
					$pseudoColor={pseudoColor}
				>
					{children}
				</LinkBase>
			);

		if (!isValidButtonType(props.type))
			throw new Error("Button type is not a valid type");

		return (
			<ButtonBase
				{...props}
				type={props.type}
				$color={color}
				$pseudoColor={pseudoColor}
			>
				{children}
			</ButtonBase>
		);
	};


export default Button;